import React from 'react';
import Camel from './Camel.react'

function Camels() {
  return (
    <div className="Camels">
      <Camel color="blue" />
      <Camel color="yellow" />
      <Camel color="orange" />
      <Camel color="white" />
      <Camel color="green" />
    </div>
  );
}

export default Camels;
